import { Button } from "react-bootstrap";

import { FilterByApplication } from "../../../../components/Filters/FilterByApplication";
import { TableSearch } from "../../../../components/TableSearch";
import type { IApplication } from "../../../../hooks/reactQueryHooks/useApplications";

interface FilterProps {
  applications: IApplication[];
  selectedItems: number;
  handleDeleteClick: () => void;
}

const Filters = ({
  applications,
  selectedItems,
  handleDeleteClick,
}: FilterProps) => {
  return (
    <div className="custom-header-wrapper">
      <div className="align-items-center position-relative">
        <TableSearch
          label={
            <>
              <strong>Search</strong> all cache items
            </>
          }
          placeholder="Type to filter..."
        />
      </div>

      {selectedItems > 0 ? (
        <div className="h-100">
          <span className="px-3">{`Selected ${selectedItems} cache item(s)`}</span>
          <Button
            size="sm"
            variant="danger"
            className="flex-shrink-0"
            type="submit"
            onClick={handleDeleteClick}
          >
            Delete selected
          </Button>
        </div>
      ) : (
        <div className="filters-wrapper position-relative">
          <FilterByApplication applications={applications} />
        </div>
      )}
    </div>
  );
};

export { Filters };
